import React from "react";
import useAccessibleDialog from "./useAccessibleDialog";

const HOW_TO_PLAY_BG = "#034c39";
const TEXT = "#e7c17f";
const BAR = "#e7c17f";
const BAR_BG = "#002d21";

const tiers = [
  { label: "90–100: Genius (Top 1%)", value: 1 },
  { label: "80–89: Very Smart", value: 9 },
  { label: "70–79: Smart", value: 17 },
  { label: "50–69: Good", value: 27 },
  { label: "30–49: Decent", value: 28 },
  { label: "0–29: Keep Trying", value: 18 },
];

export default function HowToPlayModal({ onClose }) {
  const isMobile = window.innerWidth < 500;
  const isShort = window.innerHeight < 700 && window.innerWidth < 600;
  const max = Math.max(...tiers.map((t) => t.value));
  const dialogRef = useAccessibleDialog(onClose);

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "radial-gradient(circle at center, #03715f, #034c39)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isShort ? "0.35rem" : "0.75rem",
        boxSizing: "border-box",
        zIndex: 1000,
      }}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="how-to-play-title"
        tabIndex={-1}
        style={{
          background: HOW_TO_PLAY_BG,
          color: TEXT,
          marginTop: 0,
          padding: isShort ? "0.7rem 0.9rem" : isMobile ? "1rem" : "2rem 2.5rem",
          borderRadius: "8px",
          width: isMobile ? "95%" : "90%",
          maxWidth: isMobile ? "380px" : "600px",
          minWidth: "240px",
          fontFamily: "'Baskerville', serif",
          lineHeight: isShort ? 1.2 : 1.35,
          position: "relative",
          textAlign: "left",
          fontSize: isShort ? "0.82rem" : isMobile ? "0.9rem" : "1.05rem",
          maxHeight: "calc(100dvh - 1rem)",
          boxSizing: "border-box",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch"
        }}
      >
        <button
          onClick={onClose}
          aria-label="Close how to play instructions"
          data-dialog-initial-focus
          style={{

            position: "absolute",
            top: "0.3rem",
            right: "0.55rem",
            background: "transparent",
            border: "none",
            color: TEXT,
            fontSize: isShort ? "2rem" : "2.25rem",
            lineHeight: 1,
            cursor: "pointer",
          }}
        >
          ×
        </button>

        <h2 id="how-to-play-title" style={{ fontSize: isShort ? "1.22rem" : isMobile ? "1.42rem" : "1.75rem", margin: `0 ${isMobile ? "1.75rem" : "2rem"} ${isShort ? "0.45rem" : isMobile ? "0.75rem" : "1rem"} 0`, lineHeight: 1.15 }}>
          How to Play Chronologicle
        </h2>

        <h3 style={{ fontSize: isShort ? "0.96rem" : isMobile ? "1.1rem" : "1.2rem", margin: isShort || isMobile ? "0.35rem 0 0.15rem" : "0.6rem 0 0.2rem" }}>
          Round 1:
        </h3>
        <ul style={{ margin: isShort || isMobile ? "0.1rem 0 0.35rem" : "0.2rem 0 0.55rem", paddingLeft: "1.6rem" }}>
          <li>Drag the events to order from oldest on top to most recent on bottom</li>
          <li>Fewer guesses = more points!</li>
        </ul>

        <h3 style={{ fontSize: isShort ? "0.96rem" : isMobile ? "1.1rem" : "1.2rem", margin: isShort || isMobile ? "0.35rem 0 0.15rem" : "0.6rem 0 0.2rem" }}>
          Round 2:
        </h3>
        <ul style={{ margin: isShort || isMobile ? "0.1rem 0 0.35rem" : "0.2rem 0 0.55rem", paddingLeft: "1.6rem" }}>
          <li>Use the slider to guess the year of each event.</li>
          <li>No pressure — just get as close as you can!</li>
        </ul>

        <h3 style={{ fontSize: isShort ? "0.96rem" : isMobile ? "1.1rem" : "1.2rem", margin: isShort || isMobile ? "0.35rem 0 0.15rem" : "0.6rem 0 0.2rem" }}>
          Scoring:
        </h3>

        <ul style={{ margin: isShort || isMobile ? "0.1rem 0 0.35rem" : "0.2rem 0 0.55rem", paddingLeft: "1.6rem" }}>
          <li>Round 1 - 40 Points</li>
          <li>Round 2 - 60 Points</li>
          <li>Total - 100 Points</li>
        </ul>

        <h3 style={{ fontSize: isShort ? "0.96rem" : isMobile ? "1.1rem" : "1.2rem", margin: isShort || isMobile ? "0.35rem 0 0.15rem" : "0.6rem 0 0.2rem" }}>
          What is a good Chronoscore?
        </h3>
        <div style={{ marginTop: isShort ? "0.3rem" : isMobile ? "0.5rem" : "0.75rem" }}>
          {tiers.map((tier) => (
            <div
              key={tier.label}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: isShort ? "0.2rem" : isMobile ? "0.3rem" : "0.42rem",

              }}
            >
              <div style={{ width: isMobile ? "44%" : "40%", fontSize: isShort ? "0.68rem" : isMobile ? "0.75rem" : "0.95rem", whiteSpace: "nowrap" }}>
                {tier.label}
              </div>
              <div
                style={{
                  flexGrow: 1,
                  height: isShort ? "0.65rem" : isMobile ? "0.8rem" : "0.9rem",
                  background: BAR_BG,
                  marginLeft: "0.5rem",
                  borderRadius: "4px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${(tier.value / max) * 100}%`,
                    height: "100%",
                    background: BAR,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
